module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-vehicle-asset"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.addEnabled = !_vm.addEnabled
      }
    }
  }, [_vm._v("Add Vehicle")]), (_vm.addEnabled) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.addEnabled = false
      }
    }
  }, [_vm._v("x")]), _c('label', [_vm._v("Booking Mode"), _c('BookingModeSelect', {
    model: {
      value: (_vm.bookingMode),
      callback: function($$v) {
        _vm.bookingMode = $$v
      },
      expression: "bookingMode"
    }
  })], 1), _c('label', [_vm._v("Select Vehicle"), _c('selectize-available-vehicle-slot', {
    on: {
      "optionSelected": _vm.selected
    }
  })], 1), _c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.itemSelected || !_vm.bookingMode
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a924f79c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/AddVehicleAsset.vue
// module id = 2650
// module chunks = 1